export default __webpack_public_path__ + "static/media/woman.07724ef6.png";